const equivalents = [
  ['ä', 'ae'],
  ['ö', 'oe'],
  ['ü', 'ue'],
  ['é', 'e'],
  ['è', 'e'],
  ['à', 'a'],
  ['ph', 'f'],
  ['ß', 'ss']
]

function simplifyString(s) {
  let output = s.toLowerCase()
  equivalents.forEach(e => {
    output = output.replace(e[0], e[1])
  })
  return output
}

export default {
  simplifyString
}